<ngx-extended-pdf-viewer
    [src]="blob"
    [textLayer]="true"
    [showHandToolButton]="true"
    [showPresentationModeButton]="true"
    [zoom]="zoom"></ngx-extended-pdf-viewer>
